<template>
  <div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label">{{$t('labels.email')}}:</p>
          <p class="a-input a-input--disabled">
            {{currentEmail}}
            <span class="human-data__answer-good" v-if="currentEmail == user.email.verified">
              <img src="@/assets/img/static/b-icon_ticks.svg" alt="">
              {{$t('labels.verified')}}
            </span>
            <span class="human-data__answer-bad" v-else>
              {{$t('labels.unverified')}}
            </span>
          </p>
      </div>
    </div>
    <email-verification-dialog v-if="showEmailConfirmation" @close="showEmailConfirmation = false"></email-verification-dialog>
    <div class="human-data__confirmation">
      <button class="gui-btn "
              v-if="user.email.unverified"
              @click.prevent="onResendEmailConfirmationClick"
              v-t="'buttons.request-email-confirmation'">
      </button>
      <button class="gui-btn "
              v-if="user.email.unverified && user.email.verified"
              @click.prevent="onRollbackEmailClick"
              v-t="'buttons.restore-old-email'"></button>
    </div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label">{{$t('labels.phone-short')}}:</p>
        <p class="a-input a-input--disabled">
          {{currentPhone}}
          <span class="human-data__answer-good" v-if="currentPhone == user.phone.verified">
              <img src="@/assets/img/static/b-icon_ticks.svg" alt="">
              {{$t('labels.verified')}}
          </span>
          <span class="human-data__answer-bad" v-else>
              {{$t('labels.unverified')}}
          </span>
        </p>
      </div>
    </div>
    <phone-verification-dialog v-if="showPhoneConfirmation" :eventId="eventId" @close="showPhoneConfirmation = false"></phone-verification-dialog>
    <div class="human-data__confirmation">
      <button class="gui-btn "
              v-if="user.phone.unverified"
              @click.prevent="onResendPhoneConfirmationClick"
              v-t="'buttons.request-phone-confirmation'">
      </button>
      <button class="gui-btn "
              v-if="user.phone.unverified && user.phone.verified"
              @click.prevent="onRollbackPhoneClick"
              v-t="'buttons.restore-old-phone'">
      </button>
    </div>
    <div class="human-data__block">
      <div class="a-label human-data__fio-label">{{$t('labels.username')}}:</div>
      <p class="a-input a-input--disabled">{{user | fullName}}</p>
    </div>
    <div class="human-data__block">
      <div class="a-label ">{{$t('labels.passport-series-and-number')}}:</div>
      <p class="a-input a-input--disabled">{{user.passport.series}} {{user.passport.id}}</p>
    </div>
    <div class="human-data__block human-data__block--rows" v-if="!permissions.CANNOT_SET_CATEGORIES">
      <div class="a-label ">{{$t('labels.categories')}}:</div>
      <div class="a-input a-input--disabled">
        {{categories | shortList(categoriesLimit) | defaultValue($t('form.personal-data.labels.categories-not-specified'))}}
        <span v-if="categoriesLimit == 0 || categories.length > categoriesLimit">
          <button v-if="categoriesLimit"
                  class="gui-btn gui-btn--textarea"
                  v-t="'buttons.expand'"
                  @click.prevent="categoriesLimit = 0">
          </button>
          <button v-else
                  class="gui-btn gui-btn--textarea"
                  v-t="'buttons.collapse'"
                  @click.prevent="categoriesLimit = 2">
          </button>
        </span>
      </div>
    </div>
    <div class="human-data__block" v-if="permissions.CAN_SET_DEPARTMENT">
      <div class="a-label ">{{$t('labels.department')}}:</div>
      <p class="a-input a-input--disabled">{{user.department.name | defaultValue($t('form.personal-data.labels.department-not-specified'))}}</p>
    </div>
    <div class="human-data__block">
      <div class="a-label ">{{$t('labels.status')}}:</div>
      <p class="a-input a-input--disabled">{{$t(user.state.label)}}</p>
    </div>
    <div class="human-data__block" v-if="user.roles.length > 0">
      <div class="a-label ">{{$t('labels.roles')}}:</div>
      <p class="a-input a-input--disabled">
        <span v-for="(role, idx) in user.roles">{{idx ? ', ' : ''}}{{$t(role.label)}}</span>
      </p>
    </div>
    <div class="human-data__block">
      <div class="a-label ">{{$t('labels.registration-date')}}:</div>
      <date-time class="a-input a-input--disabled" :value="user.registrationTimestamp" :time="false"></date-time>
    </div>
    <div class="human-data__block">
      <div class="a-label ">{{$t('labels.personal-data-last-change-date')}}:</div>
      <date-time class="a-input a-input--disabled" :value="user.lastChangeTimestamp" :time="false"></date-time>
    </div>
    <div class="human-data__block">
      <div class="a-label ">{{$t('labels.last-visit-date')}}:</div>
      <p class="a-input a-input--disabled">
        <date-time tag="span" :value="user.lastLoginTimestamp"></date-time>
        <span>, IP {{user.lastLoginIp}}</span>
      </p>
    </div>

    <div class="admin-buy__block-gui-btn a-flex-start">
      <button class="gui-btn gui-btn--red gui-btn--w-140"
              v-t="'buttons.modify'"
              @click.prevent="$emit('modify')" v-if="permissions.CAN_EDIT_ACCOUNT">
      </button>

      <button class="gui-btn gui-btn--red gui-btn--w-184"
              @click.prevent="onBlockUserClick"
              v-t="'buttons.block-your-self'"
              v-if="permissions.CAN_BLOCK_YOURSELF">
      </button>
    </div>

    <confirmation-dialog ref="confirmation"
                         @confirm="doOnConfirm"
                         @cancel="$refs.confirmation.close()">
    </confirmation-dialog>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import EmailVerificationDialog from '@/components/email-verification/EmailVerificationDialog'
  import PhoneVerificationDialog from '@/components/phone-verification/PhoneVerificationDialog'
  import Loading from '@/components/Loading'
  import SignDialog from '@/components/common/dialogs/SigningDialog'
  import ConfirmationDialog from '@/components/common/dialogs/ConfirmationDialog'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'


  export default {
    components: {
      Loading,
      PhoneVerificationDialog,
      EmailVerificationDialog,
      SignDialog,
      ConfirmationDialog,

      CategoriesSearch
    },
    data: () => ({
      showEmailConfirmation: false,
      showPhoneConfirmation: false,
      eventId: undefined,
      categoriesLimit: 2,
      onConfirm: undefined,
    }),
    computed: {
      currentEmail() { return this.user.email.unverified || this.user.email.verified },
      currentPhone() { return this.user.phone.unverified || this.user.phone.verified },
      permissions() { return this.$store.getters.currentUser.permissions },
      user() {
        return this.$store.getters.currentUser;
      },
      categories() {
        return (this.user.categories || []).map(c => c.name);
      }
    },

    methods: {
      async doOnConfirm() {
        await this.onConfirm();
      },

      async onResendEmailConfirmationClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('resendEmailConfirmation');
            this.showEmailConfirmation = true
          }
          catch (e) {
            console.error('unable to resend confirmation email', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onResendPhoneConfirmationClick() {
        this.runAction(async () => {
          try {
            const { eventId } = await this.$store.dispatch('resendPhoneConfirmation');
            this.eventId = eventId;
            this.showPhoneConfirmation = true;
          }
          catch (e) {
            console.error('unable to resend confirmation phone', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onRollbackEmailClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('rollbackEmail');
          }
          catch(e) {
            console.error('unable to rollback to previous email', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onRollbackPhoneClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('rollbackPhone');
          }
          catch(e) {
            console.error('unable to rollback to previous phone', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onBlockUserClick() {
        this.onConfirm = async () => {
          await this.blockUser();
        };

        this.$refs.confirmation.open({
          title: this.$t('form.user.block-confirmation.title'),
          text: this.$t('form.user.block-confirmation.body')
        });
      },

      async blockUser() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('blockUser', this.user);
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to block user', e);
            this.globalErrorHandler(e);
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
